import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';

import styles from '../../styles/icons/document-type-icon.module.css';

export interface DocumentTypeIconProps {
    type: DocumentTypeString | 'native_ad';
    withoutCircle?: boolean;
    className?: string | null;
}

const DocumentTypeIcon = ({
    type,
    withoutCircle = false,
    className = null,
}: DocumentTypeIconProps) => {
    const typeKey = camelCase(type);
    return typeof styles[typeKey] !== 'undefined' || type === 'native_ad' ? (
        <span
            className={classNames([
                styles.container,
                styles[typeKey],
                {
                    'material-symbols-rounded': type === 'native_ad',
                    [styles.withoutCircle]: withoutCircle,
                },
                className,
            ])}
        />
    ) : null;
};

export default DocumentTypeIcon;
